// run script after accessible icon clicked
document.querySelectorAll('.ab-icon__container').forEach(abIcon => {
    abIcon.addEventListener('click', () => {
      
      document.querySelector('#userwayAccessibilityIcon').click();
      
      //previous code for accessibe
      //const hostElement = document.querySelectorAll('access-widget-ui')[2];
      //const shadowRoot = hostElement.shadowRoot;
      //const button = shadowRoot.querySelector('[part="acsb-trigger"]');
      //button.click();

      // code below is overkill it just works fine by simulating a click
        // if (document.querySelector('.acsb-actions-active-icon')) {
        //     document.querySelector('.acsb-trigger').click();
        //     return;
        // }

        // // to avoid user from having to double click icon,
        // // mutation observer waits for the icon and clicks it
        // var trackingTarget = document.querySelector('body');
        // var trackingObserver = new MutationObserver(function () {
        //     if (trackingTarget.querySelector('.acsb-actions-active-icon')) {
        //         trackingObserver.disconnect();
        //         document.querySelector('.acsb-trigger').click();
        //     }
        // });
        // trackingObserver.observe(trackingTarget, { subtree: true, childList: true });

        // // implementation script
        // (function () {
        //     var s = document.createElement('script');
        //     var h = document.querySelector('head') || document.body;
        //     s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
        //     s.async = true;
        //     s.onload = function () {
        //         acsbJS.init({
        //             statementLink: '', footerHtml: '', hideMobile: false, hideTrigger: false, disableBgProcess: false, language: 'en', position: 'right', leadColor: '#146FF8', triggerColor: '#146FF8', triggerRadius: '50%', triggerPositionX: 'right', triggerPositionY: 'bottom', triggerIcon: 'people', triggerSize: 'bottom', triggerOffsetX: 20, triggerOffsetY: 20, mobile: {triggerSize: 'small', triggerPositionX: 'right', triggerPositionY: 'bottom', triggerOffsetX: 20, triggerOffsetY: 20, triggerRadius: '20'}
        //         });
        //     };
        //     h.appendChild(s);
        // })();

        // // removes accessible icon, script, and style from DOM
        // document.querySelectorAll('.ab-remove').forEach(el => {
        //     el.remove();
        // })
    })
}, { once: true })
